import { indexBy } from 'remeda';
import { createReducer } from 'typesafe-actions';

import { BlockResult } from '@block-explorer/entities';

import { PaginatedReducerState } from '../utils';
import { getPaginatedBlocksAsync, getBlockByHashAsync } from './actions';

type State = PaginatedReducerState<BlockResult>;

const initialState: State = {
  loading: false,
  error: null,
  byHash: {
    loading: false,
    error: null,
    items: {},
  },
  paginatedItems: [],
  totalItemCount: 0,
  totalPageCount: 0,
};

export default createReducer(initialState)
  .handleAction(
    getPaginatedBlocksAsync.request,
    (state, action): State => ({
      ...state,
      loading: true,
      error: null,
    })
  )
  .handleAction(
    getPaginatedBlocksAsync.failure,
    (state, action): State => ({
      ...state,
      loading: false,
      error: action.payload,
    })
  )
  .handleAction(
    getPaginatedBlocksAsync.success,
    (state, action): State => ({
      ...state,
      loading: false,
      error: null,
      paginatedItems: action.payload.data,
      byHash: {
        ...state.byHash,
        items: {
          ...state.byHash.items,
          ...indexBy(action.payload.data, (block) =>
            block.blockHash.toLowerCase()
          ),
        },
      },
      totalItemCount: action.payload.item_count,
      totalPageCount: action.payload.page_count,
    })
  )
  .handleAction(
    getBlockByHashAsync.request,
    (state, action): State => ({
      ...state,
      byHash: {
        ...state.byHash,
        loading: true,
        error: null,
      },
    })
  )
  .handleAction(
    getBlockByHashAsync.failure,
    (state, action): State => ({
      ...state,
      byHash: {
        ...state.byHash,
        loading: false,
        error: action.payload,
      },
    })
  )
  .handleAction(
    getBlockByHashAsync.success,
    (state, { payload: block }): State => ({
      ...state,
      byHash: {
        ...state.byHash,
        items: {
          ...state.byHash.items,
          [block.blockHash.toLowerCase()]: block,
        },
        loading: false,
        error: null,
      },
    })
  );
